<div class="outer-container">
  <br/>
  <div class="row">
    <div class="filter">
      <form [formGroup]="form">
        <div class="row row-cols-auto">
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="seriesFilter">{{ 'global.series' | transloco }}</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="seriesFilter"
                id="seriesFilter"
                placeholder="{{ 'components.footer.all' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="finFilter">FIN</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="finFilter"
                id="finFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="appointmentDateFilter">{{ 'modules.admin-section.preflash-monitoring.appointment-date' | transloco }}</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="appointmentDateFilter"
                id="appointmentDateFilter"
                placeholder="{{ 'global.datepicker-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="calculationTimeFilter">{{ 'modules.admin-section.preflash-monitoring.calculation-time' | transloco }}</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="calculationTimeFilter"
                id="calculationTimeFilter"
                placeholder="{{ 'global.datepicker-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="statusFilter">{{ 'global.status' | transloco }}</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="statusFilter"
                id="statusFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="systemFilter">{{ 'modules.admin-section.preflash-monitoring.system' | transloco }}</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="systemFilter"
                id="systemFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="sdpFilter">SDP</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="sdpFilter"
                id="sdpFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="vp5VersionFilter">VPS-Version</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="vp5VersionFilter"
                id="vp5VersionFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col-2-spacing">
            <div class="form-group">
              <label for="asTactFilter">AS-Tact</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control search"
                formControlName="asTactFilter"
                id="asTactFilter"
                placeholder="{{ 'modules.data-management.filter.input-placeholder' | transloco }}"
              />
            </div>
          </div>
          <div class="col">
            <div class="button-area-search">
              <button type="button" class="btn btn-primary" (click)="applyFilter()">
                {{ 'modules.data-management.filter.btn-search' | transloco }}
              </button>
              <button type="button" class="btn btn-secondary" (click)="resetFilter()">
                {{ 'modules.data-management.filter.btn-reset' | transloco }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <br/>
  <div class="row">
    <div class="col-12">
      <div class="vus-container">
        <ngx-datatable
          #dataTable
          class="material datatable-scrollable"
          [columnMode]="'flex'"
          [headerHeight]="56"
          rowHeight="auto"
          [scrollbarH]="false"
          [scrollbarV]="false"
          [rows]="filteredPreflashData"
          [footerHeight]="56"
        >
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="{{ 'global.series' | transloco }}"
            [flexGrow]="2"
            [resizeable]="false"
            prop="series"
            [sortable]="true"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
              [cellClass]="'text-right'"
              name="FIN"
              [flexGrow]="3"
              [resizeable]="false"
              prop="fin"
              [sortable]="true"
            >
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="{{ 'modules.admin-section.preflash-monitoring.appointment-date' | transloco }}"
            [flexGrow]="3"
            [resizeable]="false"
            prop="appointment_date"
            [sortable]="true"
          >
            <ng-template
                let-value="value"
                let-row="row"
                ngx-datatable-cell-template
              >
                <span *ngIf="value">{{ value | date : "dd.MM.yyyy HH:mm:ss" }}</span>
            </ng-template>
            <ng-template
              ngx-datatable-header-template
              let-column="column"
            >
              <span
                class="local-time-subheader"
                [attr.data-subtitle]="'global.local-time' | transloco"
              >
                {{ column.name }}
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="{{ 'modules.admin-section.preflash-monitoring.calculation-time' | transloco }}"
            [flexGrow]="3"
            [resizeable]="false"
            prop="calculation_time"
            [sortable]="true"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span *ngIf="value">{{ value | date : "dd.MM.yyyy HH:mm:ss" }}</span>
              <span *ngIf="!value">-</span>
            </ng-template>
            <ng-template
              ngx-datatable-header-template
              let-column="column"
            >
              <span
                class="local-time-subheader"
                [attr.data-subtitle]="'global.local-time' | transloco"
              >
                {{ column.name }}
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="Status"
            [flexGrow]="2"
            [resizeable]="false"
            prop="status"
            [sortable]="true"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span
                *ngIf="value"
                [ngClass]="'status-' + value"
                [title]="value === 'error' ? row.error_message : ''"
              >
                {{ 'modules.admin-section.preflash-monitoring.status.' + value | transloco }}
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="System"
            [flexGrow]="2"
            [resizeable]="false"
            prop="system"
            [sortable]="true"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="SDP"
            [flexGrow]="4"
            [resizeable]="false"
            prop="sdp"
            [sortable]="true"
          >
          </ngx-datatable-column>   
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="VP5-Version"
            [flexGrow]="2"
            [resizeable]="false"
            prop="vp5_version"
            [sortable]="true"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="AS-Tact"
            [flexGrow]="4"
            [resizeable]="false"
            prop="as_tact"
            [sortable]="true"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="{{ 'global.actions' | transloco }}"
            [sortable]="false"
            [flexGrow]="3"
            [resizeable]="false"
          >
            <ng-template 
              let-row="row" 
              let-rowIndex="rowIndex" 
              let-expanded="expanded" 
              ngx-datatable-cell-template
            >
              <div class="action-column">
                <span
                  style="cursor: pointer;"
                  *ngIf="row.status !== 'pending' && row.status !== 'queued'"
                  (click)="openCalculationDetails(row)"
                >
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<ng-template #calculationDetailsModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'modules.admin-section.preflash-monitoring.modal-title' | transloco }}</h5>
  </div>
  <div class="modal-body" *ngIf="selectedCalculationResult">
    <div class="preflash-store-grid">
      <div class="ecu-section">
        <table class="table table-dark table-bordered ecu-table">
          <thead>
            <tr>
              <th>{{ 'modules.admin-section.preflash-monitoring.ecu' | transloco }}</th>
              <th>{{ 'modules.admin-section.preflash-monitoring.flash-requirement' | transloco }}</th>
              <th>{{ 'modules.admin-section.preflash-monitoring.seamless' | transloco }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of objectKeys(selectedCalculationResult?.calulation_response?.result || {})">
              <td>{{ key }}</td>
              <td>
                {{ (selectedCalculationResult?.calulation_response?.result?.[key]?.flashRequirement ?
                    'modules.admin-section.preflash-monitoring.yes' :
                    'modules.admin-section.preflash-monitoring.no') | transloco }}
              </td>
              <td>
                {{ (selectedCalculationResult?.calulation_response?.result?.[key]?.seamless ?
                    'modules.admin-section.preflash-monitoring.yes' :
                    'modules.admin-section.preflash-monitoring.no') | transloco }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="details-section">
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.fin-vin' | transloco }}</label>
          <span>{{ selectedCalculationResult.fin }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.appointment' | transloco }}</label>
          <span>{{ selectedCalculationResult.appointment_date | date : 'dd.MM.yy HH:mm:ss' }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.sdp' | transloco }}</label>
          <span>{{ selectedCalculationResult.sdp }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.vps' | transloco }}</label>
          <span>{{ selectedCalculationResult.vp5_version }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.as-tact' | transloco }}</label>
          <span>{{ selectedCalculationResult.as_tact }}</span>
        </div>
        <div class="detail-row">
          <label>{{ 'modules.admin-section.preflash-monitoring.error' | transloco }}</label>
          <span>{{ selectedCalculationResult.error_message ? selectedCalculationResult.error_message : '-' }}</span>
        </div>
      </div>
    </div>
    <h6 class="history-title">{{ 'modules.admin-section.preflash-monitoring.history' | transloco }}</h6>
    <table class="table table-dark table-striped history-table">
      <thead>
        <tr>
          <th>{{ 'modules.admin-section.preflash-monitoring.nr' | transloco }}</th>
          <th>{{ 'modules.admin-section.preflash-monitoring.creation-time' | transloco }}</th>
          <th>{{ 'global.status' | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let h of selectedCalculationResult?.calulation_response?.history; let i = index; let count = count">
          <td>{{ count - i }}</td>
          <td>{{ h.creation_time | date : 'dd.MM.yy HH:mm:ss' }}</td>
          <td>
            <span [ngClass]="'status-' + h.status">
              {{ 'modules.admin-section.preflash-monitoring.status.' + h.status | transloco }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" style="margin-right: 8px;" class="btn btn-secondary" (click)="d()">
      {{ 'global.cancel' | transloco }}
    </button>
  </div>
</ng-template>
